import * as React from 'react';
import { ILocation, IArvatoLocation } from '../Types';
import { VeriLiteInformationEvent, IVeriLiteEvent, IVeriLiteEventAction, VeriLiteEventAction, InputValidation, Validation, InputValidationState } from '../../../../../Types';
import { InputGroup, InputGroupAddon, InputGroupText, Input, FormFeedback, Row, Col, ButtonGroup, Button, CustomInput } from 'reactstrap';
import { Auth, AuthenticationService } from '../../../../../Services/AuthenticationService';
import { defaultPostOptions, UserRequestHeaders, saysWho } from '../../../../../Services/Util';
import { Overlay, CustomSpinner, Center } from '../../../../../Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faEye, faCloudUploadAlt, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { EventHandlerProvider } from '../../../../../Services/EventHandlerService';
import { IAuthenticatedAppData } from '../../../../../AuthenticatedApp/AuthenticatedApp';
import '../Styles/AddArvatoLocationEventContent.css';
import Endpoints from '../../../../../Utils/Endpoints';

interface INewLocationValidation {
    [key: string]: InputValidation;
    Name: InputValidation;
    ClientId: InputValidation;
    UserId: InputValidation;
    Password: InputValidation;
    Type: InputValidation;
}

enum ArvatoRenewCertEventContentState {
    Initial,
    Certificate,
    TAN,
    File,
    Pass,
    Pending,
    Success,
    Error
}

enum CertInputType {
    unset,
    TAN,
    File
}

interface IArvatoRenewCertEventContentState {
    LocationDataValidation: INewLocationValidation;
    LocationData: IArvatoLocation;
    Status: ArvatoRenewCertEventContentState;
    ApplicationValidation: Validation;
    ShowPassword: boolean;
    TAN: string;
    TanValidation: InputValidation;
    CertFile: any;
    CertFileValidation: InputValidation;
    CertPassPhrase: string;
    CertPassPhraseValidation: InputValidation;
    selectedCertInputType: CertInputType;
}

interface IArvatoRenewCertEventContentProps {
    updateCallback: (location: string, expiry: string) => void;
    applicationData: IAuthenticatedAppData;
    locationName: string;
}

export class ArvatoRenewCertEventContent extends React.Component<IArvatoRenewCertEventContentProps, IArvatoRenewCertEventContentState>{

    tanButtonRef: React.RefObject<HTMLButtonElement>;
    certFileButtonRef: React.RefObject<HTMLButtonElement>;

    constructor(props: IArvatoRenewCertEventContentProps) {
        super(props);

        this.state = {
            LocationData: {} as IArvatoLocation,
            LocationDataValidation: {
                Name: new InputValidation(true, props.applicationData.resources.ValidationError_LocationNameInvalid, /^\S+.{1,}\S$/),
                ClientId: new InputValidation(true, props.applicationData.resources.ValidationError_ClientIdInvalid, /^[a-zA-Z]{3,6}$/),
                UserId: new InputValidation(true, props.applicationData.resources.ValidationError_UserIdInvalid, /^[a-zA-Z0-9]{6,10}$/),
                Password: new InputValidation(),
                Type: new InputValidation()
            },
            Status: ArvatoRenewCertEventContentState.Initial,
            ApplicationValidation: new Validation(),
            ShowPassword: false,
            TAN: "",
            TanValidation: new InputValidation(true, props.applicationData.resources.ValidationError_TANInvalid, /^[a-zA-Z0-9]{6,10}$/),
            selectedCertInputType: CertInputType.unset,
            CertFile: "",
            CertFileValidation: new InputValidation(),
            CertPassPhrase: "",
            CertPassPhraseValidation: new InputValidation()
        };

        this.tanButtonRef = React.createRef<HTMLButtonElement>();
        this.certFileButtonRef = React.createRef<HTMLButtonElement>();
    }

    private updateTan = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ TAN: event.target.value }, () => { this.setState({ TanValidation: this.state.TanValidation.validate(this.state.TAN) }) });
    }

    private updateCertFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        var files = event.target.files;
        if (!files || !files.length) {
            return;
        }

        if (!event.target.value.match(/(.pfx|.p12)+$/g)) {
            this.setState({ ApplicationValidation: new Validation(this.props.applicationData.resources.Upload_WrongFormat, InputValidationState.invalid)});
            return;
        }

        var file = files[0];
        var reader = new FileReader();
        reader.onloadend = (event: ProgressEvent<FileReader>) => {
            this.setState({ CertFile: event.target?.result },()=>this.updateModal(ArvatoRenewCertEventContentState.Pass));
        }
        reader.readAsDataURL(file);
    }


    private updateCertPassPhrase = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ CertPassPhrase: event.target.value }, () => { this.setState({ TanValidation: this.state.TanValidation.validate(this.state.TAN) }) });
    }

    updateLocation = async () => {
        this.updateModal(ArvatoRenewCertEventContentState.Pending);

        var options: RequestInit = {};

        options = Object.assign({ ...defaultPostOptions }, options);
        var json;
        var endpoint;
        if (this.state.Status == ArvatoRenewCertEventContentState.TAN) {
            json = JSON.stringify({ location: this.props.locationName, Tan: this.state.TAN });
            endpoint = Endpoints.RenewCertFromTan;
        }
        else {
            json = JSON.stringify({ location: this.props.locationName, Cert: this.state.CertFile, Pass: this.state.CertPassPhrase });
            endpoint = Endpoints.RenewCertFromCert
        }
        options = { ...options, body: json };

        var userRequestHeaders = new UserRequestHeaders(Auth.getUser());
        var headers = new Headers(options.headers);

        await Auth.getAccessToken().then((token) => {
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });

        userRequestHeaders.AppendHeaders(options);

        fetch(endpoint, options).then((response) => {
            if (!response.ok) {
                response.json().then((validationResponse) => {
                    if (validationResponse.name == "AddLocation_WrongCertPass") {
                        var certPassValidation = this.state.CertPassPhraseValidation;
                        certPassValidation.Validation = new Validation(this.props.applicationData.resources[validationResponse.name], InputValidationState.invalid);
                        this.setState({ CertPassPhraseValidation: { ...this.state.CertPassPhraseValidation, } }, () => this.updateModal(ArvatoRenewCertEventContentState.Pass));
                    }
                    else if (validationResponse.includes("Certificate cannot be uploaded before its activation date on:")) {
                        this.setState({ ApplicationValidation: { Error: validationResponse, State: InputValidationState.invalid } as Validation }, () =>
                        this.updateModal(ArvatoRenewCertEventContentState.Error))
                    }
                    else {
                        this.setState({ ApplicationValidation: { Error: this.props.applicationData.resources[validationResponse.name], State: InputValidationState.invalid } as Validation }, () => this.updateModal(ArvatoRenewCertEventContentState.Error));
                    }
                });
            }
            else {
                this.updateModal(ArvatoRenewCertEventContentState.Success);
            }
        }).catch((err) => {
            this.updateModal(ArvatoRenewCertEventContentState.Error);
            console.error("Error adding new location:");
            console.error(err);
        });
    };
    public next = () => {
        this.updateModal(ArvatoRenewCertEventContentState.Certificate);
    }
    public resetModal = (closeModalCallback: (actionCallback?: () => void) => void) => {
        this.setState({ selectedCertInputType: CertInputType.unset });
        this.setState({ Status: ArvatoRenewCertEventContentState.Initial }, () => {
            closeModalCallback();
        });

    }

    private updateModal = (newState: ArvatoRenewCertEventContentState) => {
        this.setState({ Status: newState });
        switch (newState) {
            case ArvatoRenewCertEventContentState.Initial:
                this.setState({ selectedCertInputType: CertInputType.unset });
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.ConfirmCertRenewal_Title;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Yes,
                        "primary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.updateModal(ArvatoRenewCertEventContentState.Certificate);
                        }
                    ), new VeriLiteEventAction(
                        this.props.applicationData.resources.Close,
                        "secondary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
            case ArvatoRenewCertEventContentState.Certificate:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.ConfirmCertRenewal_Title;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Next,
                        "primary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            if (this.state.selectedCertInputType == CertInputType.unset) {
                                this.setState({ ApplicationValidation: new Validation(this.props.applicationData.resources.ValidationError_CertInputType, InputValidationState.invalid) });
                                return;
                            }
                            else if (this.state.selectedCertInputType == CertInputType.TAN) {
                                this.updateModal(ArvatoRenewCertEventContentState.TAN)
                            }
                            else {
                                this.updateModal(ArvatoRenewCertEventContentState.File)
                            }
                        }
                    ), new VeriLiteEventAction(
                        this.props.applicationData.resources.Close,
                        "secondary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
            case ArvatoRenewCertEventContentState.Success:

                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.Success;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Finish,
                        "primary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
            case ArvatoRenewCertEventContentState.Error:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.Error;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Close,
                        "secondary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
            case ArvatoRenewCertEventContentState.Pending:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.LoadingDotDotDot;
                event.actions = [];

                eventHandler.UpdateEvent();
                break;
            case ArvatoRenewCertEventContentState.TAN:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.ConfirmCertRenewal_Title;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.SetupLocations_AddLocation,
                        "primary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.updateLocation();
                        })
                    ,
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Close,
                        "secondary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];
                break;
            case ArvatoRenewCertEventContentState.File:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.ConfirmCertRenewal_Title;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Close,
                        "secondary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
            case ArvatoRenewCertEventContentState.Pass:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.applicationData.resources.CreateLocation_Heading;
                event.actions = [
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.SetupLocations_AddLocation,
                        "primary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            this.updateLocation();
                        }
                    ),
                    new VeriLiteEventAction(
                        this.props.applicationData.resources.Close,
                        "secondary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.setState({ Status: ArvatoRenewCertEventContentState.Initial });
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
        }
    };

    changeCertInputType = (newSelectedType: number) => {
        if (this.state.selectedCertInputType != newSelectedType) {
            this.setState({selectedCertInputType: newSelectedType });
        }
        this.certFileButtonRef.current?.blur();
        this.tanButtonRef.current?.blur();
    }

    render() {
        switch (this.state.Status) {
            case ArvatoRenewCertEventContentState.Initial:
                return (<div>
                    <div id="create_location_message" className="my-3">
                        {this.props.applicationData.resources.ConfirmCertRenewal_InitialMessage}
                    </div>
                </div>);
            case ArvatoRenewCertEventContentState.Certificate:
                return (<div>
                    <div id="create_location_message" className="my-3">
                        {this.props.applicationData.resources.Create_Location_Arvato_Cert}
                    </div>
                    <CustomInput type="radio" id="tanRadio" name="certradio" label={this.props.applicationData.resources.Tan} onChange={() => this.setState({ selectedCertInputType: CertInputType.TAN})}/>
                    <CustomInput type="radio" id="fileRadio" name="certradio" label={this.props.applicationData.resources.CertificateFile} onChange={() => this.setState({ selectedCertInputType: CertInputType.File })} />
                </div>);
            case ArvatoRenewCertEventContentState.TAN:
                return (<div>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.applicationData.resources.Tan} </InputGroupText>
                        </InputGroupAddon>
                        <Input valid={this.state.TanValidation.isValid()} invalid={this.state.TanValidation.isInvalid()} onChange={(e) => this.updateTan(e)} value={this.state.TAN} />
                        <FormFeedback style={{ textAlign: "right" }}>{this.state.TanValidation.isInvalid() ? this.state.TanValidation.Validation.Error : ""}</FormFeedback>
                    </InputGroup>
                </div>);
            case ArvatoRenewCertEventContentState.File:
                return (<div>
                    <div id="create_location_message" className="my-3">
                        {this.props.applicationData.resources.Create_Location_Arvato_Cert_File}
                    </div>
                    <Center horizontal>
                        <Button outline color="primary"><label className="my-0" htmlFor="cert-input" style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faCloudUploadAlt} />   {this.props.applicationData.resources.UploadCertificate}</label></Button>
                        <input style={{ display: "none" }} id="cert-input" type="file" onChange={this.updateCertFile} accept=".pfx,.p12" />
                    </Center>
                    {this.state.ApplicationValidation.isInvalid() && <FormFeedback style={{ display: "block" }}>{this.state.ApplicationValidation.Error}</FormFeedback>}
                </div>);
            case ArvatoRenewCertEventContentState.Pass:
                return (<div>
                    <div className="my-3">
                        {this.props.applicationData.resources.Create_Location_PassPhrase}
                    </div>
                    <InputGroup className="my-3" style={{ display: "flex", alignItems: "center" }}>
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.applicationData.resources.CertificatePassphrase} </InputGroupText>
                        </InputGroupAddon>
                        <Input valid={this.state.CertPassPhraseValidation.isValid()} invalid={this.state.CertPassPhraseValidation.isInvalid()} onChange={(e) => this.updateCertPassPhrase(e)} value={this.state.CertPassPhrase} type={this.state.ShowPassword ? "text" : "password"} /> {this.state.CertPassPhrase?.length > 0 && saysWho().name != "IE" && <FontAwesomeIcon onMouseDown={() => this.setState({ ShowPassword: true })} onMouseUp={() => this.setState({ ShowPassword: false })} icon={faEye} className="show-password" />}
                        <FormFeedback style={{ textAlign: "right" }}>{this.state.CertPassPhraseValidation.isInvalid() ? this.state.CertPassPhraseValidation.Validation.Error : ""}</FormFeedback>
                    </InputGroup>
                </div>);
            case ArvatoRenewCertEventContentState.Pending:
                return (<Center horizontal vertical ><CustomSpinner /></Center>);
            case ArvatoRenewCertEventContentState.Success:
                return (<div>
                    <Row className="text-success mb-2">
                        <Col />
                        <Col xs="auto" >
                            <FontAwesomeIcon size="6x" icon={faCheckCircle} />
                        </Col>
                        <Col />
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto" >
                            {this.props.applicationData.resources.AddLocationSuccessMessage}
                        </Col>
                        <Col />
                    </Row>
                </div>);
            case ArvatoRenewCertEventContentState.Error:
                return (<div>
                    <Row className="text-danger mb-2">
                        <Col />
                        <Col xs="auto" >
                            <FontAwesomeIcon size="6x" icon={faTimesCircle} />
                        </Col>
                        <Col />
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto" >
                            {this.state.ApplicationValidation.Error || this.props.applicationData.resources.AnErrorHasOccurred}
                        </Col>
                        <Col />
                    </Row>
                </div>);
        }
    }
}
